import axios from "axios";

import { PaymentSessionToken } from "redmond";
import { purchaseApi } from "@b2bportal/purchase-api";

const closeSession = (token: PaymentSessionToken): Promise<any> =>
  new Promise((resolve, reject) => {
    try {
      const res = purchaseApi(axios).apiV0PurchaseQuoteDiscardPost({
        value: token.value,
      });

      res.then((body) => resolve(body.data)).catch((e) => reject(e));
    } catch (e) {
      reject(e);
    }
  });

export default closeSession;
